import type { CSSProperties } from 'react';
import ColorChip from './ColorChip';
import {
  levelAlternativeChipColors,
  levelChipColors,
} from '../../utils/colorHandler';
import barracudaImage from '../../assets/class/sof/barracuda.png';
import dolphinImage from '../../assets/class/sof/dolphin.png';
import seahorseImage from '../../assets/class/sof/seahorse.png';
import sealImage from '../../assets/class/sof/seal.png';
import starfishImage from '../../assets/class/sof/starfish.png';
import swordfishImage from '../../assets/class/sof/swordfish.png';

const sofLevelBadgeImages: Record<string, string> = {
  barracuda: barracudaImage,
  dolphin: dolphinImage,
  seahorse: seahorseImage,
  seal: sealImage,
  starfish: starfishImage,
  swordfish: swordfishImage,
};

const SOF_LEVEL_BADGE_SIZE = 30;

type SofLevelChipProps = {
  level?: string | null;
  serviceType?: string | null;
  badgeSize?: number;
  emptyLabel?: string;
  style?: CSSProperties;
};

const SofLevelChip = ({
  level,
  serviceType,
  badgeSize = SOF_LEVEL_BADGE_SIZE,
  emptyLabel = 'None',
  style,
}: SofLevelChipProps) => {
  const normalizedLevel = level?.trim().toLowerCase();
  const badgeImage =
    serviceType?.trim().toLowerCase() === 'sof' && normalizedLevel
      ? sofLevelBadgeImages[normalizedLevel]
      : undefined;

  // Title-case key (e.g. "barracuda" -> "Barracuda") so the chip text/background
  // colors line up with the level badge palette.
  const paletteKey = normalizedLevel
    ? normalizedLevel.charAt(0).toUpperCase() + normalizedLevel.slice(1)
    : undefined;

  return (
    <ColorChip
      label={level}
      palette={{ ...levelChipColors, ...levelAlternativeChipColors }}
      paletteKey={paletteKey}
      emptyLabel={emptyLabel}
      style={style}
      icon={
        badgeImage ? (
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: badgeSize,
              height: badgeSize,
              flex: '0 0 auto',
            }}
          >
            <img
              src={badgeImage}
              alt=""
              aria-hidden="true"
              style={{
                width: badgeSize,
                height: badgeSize,
                objectFit: 'contain',
                display: 'block',
              }}
            />
          </span>
        ) : undefined
      }
    />
  );
};

export default SofLevelChip;
